import React from 'react';
import styled from 'styled-components';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <FooterContent>
        <Copyright>© {currentYear} Stoic Wisdom. All rights reserved.</Copyright>
        <FooterText>
          Embracing the wisdom of Stoic philosophers to navigate modern challenges.
        </FooterText>
      </FooterContent>
    </FooterContainer>
  );
};

const FooterContainer = styled.footer`
  padding: 1rem 1rem;
  background: linear-gradient(to top, #000000, #111111);
  border-top: 1px solid #d4af37;
  margin-top: auto;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 150px;
    height: 1px;
    background: linear-gradient(to right, transparent, #d4af37, transparent);
  }
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Copyright = styled.p`
  font-size: 0.8rem;
  color: var(--color-secondary);
  margin-bottom: 0.3rem;
  letter-spacing: 0.5px;
`;

const FooterText = styled.p`
  font-size: 0.7rem;
  color: var(--color-secondary);
  font-style: italic;
  max-width: 600px;
  line-height: 1.4;
`;

export default Footer;
